import { render, staticRenderFns } from "./HistoryPackageHistory.vue?vue&type=template&id=747ef035&scoped=true"
import script from "./HistoryPackageHistory.vue?vue&type=script&lang=js"
export * from "./HistoryPackageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747ef035",
  null
  
)

export default component.exports